import { render, staticRenderFns } from "./milestone.vue?vue&type=template&id=0167635e&scoped=true"
import script from "./milestone.vue?vue&type=script&lang=js"
export * from "./milestone.vue?vue&type=script&lang=js"
import style0 from "./milestone.vue?vue&type=style&index=0&id=0167635e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0167635e",
  null
  
)

export default component.exports